module.exports = __webpack_public_path__ + "img/settings-active-icon.2ec03f10.svg";